module.exports = __webpack_public_path__ + "static/img/28.7ac8e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/28.jpg
// module id = lX4O
// module chunks = 0